/* tslint:disable */

/**
 */
export class DuplicateEltNewSizeParam {
    nbModule?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/duplicate-elt-new-size-param.ts